import { Group, Notification, NotificationProps, Box } from '@mantine/core';
import { NotificationData, notifications } from '@mantine/notifications';
import styles from './Toast.module.css';
import { cva, VariantProps } from 'class-variance-authority';
import {
    IconInfoCircle,
    IconCircleCheck,
    IconAlertTriangle,
    IconAlertCircle,
    IconProps,
} from '@tabler/icons-react';
import { FC } from 'react';

const NEUTRAL = 'neutral';

const toastVariants = cva(styles.base, {
    variants: {
        status: {
            neutral: styles.neutral,
            info: styles.info,
            positive: styles.positive,
            caution: styles.caution,
            negative: styles.negative,
        },
    },
    defaultVariants: {
        status: NEUTRAL,
    },
});

const statusToIconMap: Record<NonNullable<VariantProps<typeof toastVariants>['status']>, FC<IconProps>> = {
    neutral: IconInfoCircle,
    info: IconInfoCircle,
    positive: IconCircleCheck,
    caution: IconAlertTriangle,
    negative: IconAlertCircle,
};

export type ShowToastParams = NotificationData & VariantProps<typeof toastVariants>;

export const Toast = ({
    status,
    title,
    children,
    ...props
}: NotificationProps & VariantProps<typeof toastVariants>) => {
    const Icon = statusToIconMap[status ?? 'neutral'];
    return (
        <Notification
            className={toastVariants({ status })}
            title={
                <Group justify="start" gap="4px" align={'center'}>
                    <Icon className={'datavant-Alert-icon'} />
                    <Box maw={'90%'}>{title}</Box>
                </Group>
            }
            {...props}
        >
            {children}
        </Notification>
    );
};

export const showToast = ({
    status,
    title,
    message,
    withCloseButton = true,
    ...props
}: ShowToastParams): string => {
    const Icon = statusToIconMap[status ?? 'neutral'];
    return notifications.show({
        className: toastVariants({ status }),
        title: (
            <Group justify="start" gap="4px" align={'center'}>
                <Icon className={'datavant-Alert-icon'} />
                <Box maw={'90%'}>{title}</Box>
            </Group>
        ),
        message,
        withCloseButton,
        ...props,
    });
};
